/**
 * Trim `text` to at most `max` characters, cutting on a word boundary and adding
 * an ellipsis only when something was actually removed.
 *
 * This exists because three places independently did `str.slice(0, n) + '...'`,
 * which publishes titles that end mid-word — "…Demand Forecas..." — and reads as
 * broken in a SERP. Google truncating a slightly-long title looks fine; a title
 * that arrives pre-broken does not.
 *
 * Treat it as a safety net, not a licence to author long titles: anything that
 * relies on it is already too long to render in full.
 */
export function truncateOnWord(text: string, max: number): string {
  if (text.length <= max) return text;
  // Leave room for the ellipsis, then step back to the last space.
  const clipped = text.slice(0, max - 1);
  const lastSpace = clipped.lastIndexOf(' ');
  const body = lastSpace > max * 0.5 ? clipped.slice(0, lastSpace) : clipped;
  return `${body.replace(/[\s–—\-|,:;.]+$/, '')}…`;
}
